// Re-export placeholder for stats store - to be implemented later
export const StatsStore = null;
export type StatsStoreType = any;
